import req from "../http";

const supervisor = {
  // 取得 待面談(依據使用者所屬部門)
  getInInterviewPaging(params, userId) {
    return req("get", `/Progress/ByInInterview/paging/${userId}`, params);
  },

  //  取得 已面談(依據使用者所屬部門)
  getInterviewedPaging(params, userId) {
    return req("get", `/Progress/ByInterviewed/paging/${userId}`, params);
  },

  //  取得 面談結果(依據使用者所屬部門)
  getInterviewResultPaging(params, userId) {
    return req("get", `/Progress/InterviewResult/paging/${userId}`, params);
  },

  //  取得 任用結果(依據使用者所屬部門)
  getAppointmentResultPaging(params, userId) {
    return req("get", `/Progress/AppointmentResult/paging/${userId}`, params);
  },

  // 報到查詢(依據使用者所屬部門)
  getOnBoardPaging(params, userId) {
    return req("get", `/Progress/OnBoard/paging/${userId}`, params);
  },
};

export default supervisor;